module.exports = __webpack_public_path__ + "static/media/media2.082f1882.jpg";